export default __webpack_public_path__ + "static/media/retakeTataNeu.c4433ff9.png";